import React from 'react';
import { ChevronLeft, Star, Bell, CheckCircle } from 'lucide-react';
import './QuestionnaireFlowHeader.css';

/**
 * QuestionnaireFlowHeader — Skillshare-style header bar for the questionnaire flow.
 *
 * Left:  "< Home" breadcrumb + question ID & title
 * Right: "Leave a rating" button, "Remind" button, overflow menu
 */
const QuestionnaireFlowHeader = ({
  questionId,
  questionTitle,
  onGoHome,
  onLeaveRating,
  onRemind,
  feedbackDone,
}) => {
  const displayTitle = questionTitle
    ? `${questionId}: ${questionTitle}`
    : questionId;

  return (
    <header className="qf-header">
      <div className="qf-header__left">
        <button className="qf-header__home-btn" onClick={onGoHome}>
          <ChevronLeft size={18} />
          <span>Home</span>
        </button>
        <span className="qf-header__divider" />
        <span className="qf-header__title" title={displayTitle}>
          {displayTitle}
        </span>
      </div>

      <div className="qf-header__right">
        <button
          className={`qf-header__action ${feedbackDone ? 'qf-header__action--rated' : ''}`}
          onClick={onLeaveRating}
          aria-label={feedbackDone ? 'Rated' : 'Leave a rating'}
        >
          {feedbackDone ? <CheckCircle size={16} /> : <Star size={16} />}
          <span className="qf-header__action-label">
            {feedbackDone ? 'Rated' : 'Leave a rating'}
          </span>
        </button>
        <button className="qf-header__action qf-header__action--primary" onClick={onRemind} aria-label="Remind">
          <Bell size={16} />
          <span className="qf-header__action-label">Remind</span>
        </button>
      </div>
    </header>
  );
};

export default QuestionnaireFlowHeader;
